export default __webpack_public_path__ + "static/media/chris-blackburn.5cd95b9f.png";